import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Loader = _resolveComponent("Loader")
  const _component_AgentEditor = _resolveComponent("AgentEditor")
  const _component_SplitterPanel = _resolveComponent("SplitterPanel")
  const _component_AgentsList = _resolveComponent("AgentsList")
  const _component_Splitter = _resolveComponent("Splitter")
  const _component_SettingsFrame = _resolveComponent("SettingsFrame")

  return (_openBlock(), _createBlock(_component_SettingsFrame, { class: "agents-frame" }, {
    default: _withCtx(() => [
      (!$data.agents)
        ? (_openBlock(), _createBlock(_component_Loader, { key: 0 }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Loading test agents...")
            ])),
            _: 1 /* STABLE */
          }))
        : (_openBlock(), _createBlock(_component_Splitter, {
            key: 1,
            class: "agents-panel",
            unstyled: false,
            disabled: $data.saving
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SplitterPanel, {
                class: "editor-panel",
                unstyled: false,
                size: 50,
                "min-size": 20
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AgentEditor, {
                    ref: "editor",
                    "vread-from": "editing_idx",
                    "onUpdate:editing_idx": $event => (($data.editing_idx) = $event),
                    agents: $data.agents,
                    tools: $data.tools,
                    onAdd: $options.createAgent,
                    onSave: $options.saveAgent
                  }, null, 8 /* PROPS */, ["onUpdate:editing_idx", "agents", "tools", "onAdd", "onSave"])
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_SplitterPanel, {
                class: "list-panel",
                unstyled: false,
                size: 50,
                "min-size": 20
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_AgentsList, {
                    agents: $data.agents,
                    editing_idx: $data.editing_idx,
                    saving: $data.saving,
                    saved_at: $data.saved_at,
                    onEdit: _cache[0] || (_cache[0] = (agent, index) => _ctx.$refs.editor.edit(agent, index)),
                    onDelete: $options.deleteAgent
                  }, null, 8 /* PROPS */, ["agents", "editing_idx", "saving", "saved_at", "onDelete"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"]))
    ]),
    _: 1 /* STABLE */
  }))
}